module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0009.7f3a86b1.jpg";